var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChartKanban = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 3C15 2.17157 14.3284 1.5 13.5 1.5H10.5C9.67157 1.5 9 2.17157 9 3V12C9 12.8284 9.67157 13.5 10.5 13.5H13.5C14.3284 13.5 15 12.8284 15 12V3ZM13.5 3.3C13.5 3.13431 13.3657 3 13.2 3H10.8C10.6343 3 10.5 3.13431 10.5 3.3V11.7C10.5 11.8657 10.6343 12 10.8 12H13.2C13.3657 12 13.5 11.8657 13.5 11.7V3.3Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.5 3C7.5 2.17157 6.82843 1.5 6 1.5H3C2.17157 1.5 1.5 2.17157 1.5 3V16.5C1.5 17.3284 2.17157 18 3 18H6C6.82843 18 7.5 17.3284 7.5 16.5V3ZM6 3.3C6 3.13431 5.86569 3 5.7 3H3.3C3.13431 3 3 3.13431 3 3.3V16.2C3 16.3657 3.13431 16.5 3.3 16.5H5.7C5.86569 16.5 6 16.3657 6 16.2V3.3Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.5 3C22.5 2.17157 21.8284 1.5 21 1.5H18C17.1716 1.5 16.5 2.17157 16.5 3V21C16.5 21.8284 17.1716 22.5 18 22.5H21C21.8284 22.5 22.5 21.8284 22.5 21V3ZM21 3.3C21 3.13431 20.8657 3 20.7 3H18.3C18.1343 3 18 3.13431 18 3.3V20.7C18 20.8657 18.1343 21 18.3 21H20.7C20.8657 21 21 20.8657 21 20.7V3.3Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgChartKanban);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chart-kanban.2a952d3fa13a7d486be8852916202807.svg";